$(document).ready(function () {
    document.querySelectorAll("input[data-format]").forEach((input) => {
        input.addEventListener("input", function (e) {
            let primaryFormat = this.getAttribute("data-format");
            let altFormat = this.getAttribute("data-alt-format");
            let rawValue = this.value;
            let value = rawValue.replace(/[^a-zA-Z0-9]/g, ""); // Remove caracteres que não são letras ou números

            // Aplica os formatos
            let formattedPrimary = applyFormat(value, primaryFormat);
            let formattedAlt = altFormat ? applyFormat(value, altFormat) : "";

            // Escolhe o melhor formato baseado na entrada
            this.value = determineBestFormat(
                value,
                formattedPrimary,
                formattedAlt,
                primaryFormat,
                altFormat
            );
        });
    });

    function applyFormat(value, format) {
        let finalValue = "";
        let index = 0;
        for (let i = 0; i < format.length && index < value.length; i++) {
            if (
                (format[i] === "9" && /\d/.test(value[index])) ||
                (format[i] === "X" && /[a-zA-Z]/.test(value[index]))
            ) {
                finalValue += format[i] === "X" ? value[index].toUpperCase() : value[index]; // Converte apenas letras para maiúsculas
                index++;
            } else if (format[i] !== "9" && format[i] !== "X") {
                finalValue += format[i]; // Adiciona o caractere de formatação
            } else {
                // Se o caractere não corresponde ao padrão, ainda assim incrementa o índice
                // para não truncar o valor e continuar processando os próximos caracteres
                index++;
                i--; // Volta uma posição no formato para tentar novamente com o próximo caractere
            }
        }
        return finalValue;
    }

    function determineBestFormat(
        value,
        primary,
        alternate,
        primaryFormat,
        alternateFormat
    ) {
        let primaryConsumption = primary.replace(/[^0-9A-Z]/g, "").length;
        let alternateConsumption = alternate.replace(/[^0-9A-Z]/g, "").length;
        let valueLength = value.length;

        // Preferir o formato que mais se aproxima de utilizar todos os caracteres digitados
        if (
            alternate &&
            alternateConsumption > primaryConsumption &&
            alternateConsumption == valueLength
        ) {
            return alternate;
        } else if (primaryConsumption == valueLength) {
            return primary;
        }

        return primaryConsumption >= alternateConsumption ? primary : alternate;
    }
});
